export const APP_SETTINGS = {
  COUNTRIES: {
    CHILE: {
      SHORT_NAME: 'cl',
    },
    PERU: {
      SHORT_NAME: 'pe',
    },
  },
};
